export interface TToolListItem {
  key: string;
  name: string;
  icon: string;
  auth?: string;
  link?: string;
}
export const toolList = [
  {
    key:'add-employee',
    name: window.$xinI18n('添加员工','BonusPackage-tianjiayuangong'),
    icon:'user-add-fill',
    auth: 'employee_info',
    link:'/employee/addEmployee?emptype=0'
  },
  {
    key:'report-employee',
    name: window.$xinI18n('导入员工','BatchUpload-BonusPackageIndividuals-daoruyuangong'),
    icon:'user-shared-fill',
    auth: 'employee_import',
    link: '/employee/batch-upload?type=EmployeeAdd'
  },
  {
    key:'report-employee-info',
    name: window.$xinI18n('导入员工信息','employee-daoruyuangongxinxi'),
    icon:'contacts-fill',
    auth: 'employee_import_info',
    link: '/employee/batch-upload?type=EmployeeModify',
    tooltip:true
  },
  {
    key:'monthly-personnel-report',
    name: window.$xinI18n('人事月报','Home-shortcut-renshiyuebao'),
    auth: 'employee_view_report',
    icon:'folder-user-line',
    tooltip:true
  },
  {
    key:'attendance-setting',
    name: window.$xinI18n('考勤设置','Home-shortcut-kaoqinshezhi'),
    icon:'settings-2-fill',
    auth:'attendance_view_daka_plan'
  },
  {
    key:'attendance-report',
    name: window.$xinI18n('考勤报表','Home-shortcut-kaoqinbaobiao'),
    icon:'file-text-fill',
    auth:'attendance_month_report',
    link: '/attendance/report'
  },
  {
    key: 'employee-tool',
    name: window.$xinI18n('员工成本计算', 'Home-shortcut-yaungongchengbenjisuan'),
    icon: 'user-CNY-fill',
  },
  {
    key:'payroll-tool',
    name: window.$xinI18n('税前工资反推', 'Home-shortcut-gongzifantuijisuan'),
    icon: 'funds-box-fill',
    tooltip:true
  },
  {
    key: 'insurance-tool',
    name: window.$xinI18n('社保公积金测算', 'Home-shortcut-shebaogongjijincesuan'),
    icon: 'exchange-box-fill',
    tooltip:true
  },
  {
    key: 'option-tool',
    name: window.$xinI18n('期权授予计算', 'Home-shortcut-qiquanjisuan'),
    icon: 'percent-fill'
  }
]
export const ChildrenEducationDeductionOption = [
  {
    value: 0,
    text: window.$xinI18n('不符合，扣除0元', 'Home-shortcut-bufuhekou0yuan')
  },
  {
    value: 500,
    text: window.$xinI18n('一个孩子，夫妻各扣除500元', 'Home-shortcut-yigehaizikouchu500')
  },
  {
    value: 1000,
    text: window.$xinI18n('一个孩子，仅有一方扣除1000元', 'Home-shortcut-yigehaiziyifangkouchu500')
  },
  {
    value: '1000',
    text: window.$xinI18n('两个孩子，夫妻各扣除1000元', 'Home-shortcut-lianggehaizigekouchu1000yuan')
  },
  {
    value: 2000,
    text: window.$xinI18n('两个孩子，仅有一方扣除2000元', 'Home-shortcut-lianggehaiziyifangkouchu2000yuan')
  }
];

export const ContinuingEducationDeductionOption = [
  {
    value: 0,
    text: window.$xinI18n('不符合，扣除0元', 'Home-shortcut-bufuhekou0yuan')
  },
  {
    value: 400,
    text: window.$xinI18n('接受学历教育中，扣除400', 'Home-shortcut-jieshoujiaoyuzhongkouchu400')
  }
];

export const SupportElderlyDeductionTypeOption = [
  {
    value: 0,
    text: window.$xinI18n('指定分摊', 'Home-shortcut-zhidingfentan')
  },
  {
    value: 1,
    text: window.$xinI18n('约定分摊', 'Home-shortcut-yuedingfentan')
  }
];

export const SupportElderlyDeductionOption = [
  {
    value: 0,
    text: window.$xinI18n('不符合，扣除0元', 'Home-shortcut-bufuhekou0yuan')
  },
  {
    value: 2000,
    text: window.$xinI18n('独生子女，扣除2000元', 'Hom-shortcut-dushengzinvkou2000')
  },
  {
    value: 1000,
    text: window.$xinI18n('两', 'Home-shortcut-liang') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [1000])
  },
  {
    value: 666.7,
    text: window.$xinI18n('三', 'Home-shortcut-san') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [666.7])
  },
  {
    value: 500,
    text: window.$xinI18n('四', 'Home-shortcut-si') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [500])
  },
  {
    value: 400,
    text: window.$xinI18n('五', 'Home-shortcut-wu') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [400])
  },
  {
    value: 333.3,
    text: window.$xinI18n('六', 'Home-shortcut-liu') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [333.3])
  },
  {
    value: 285.7,
    text: window.$xinI18n('七', 'Home-shortcut-qi') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [285.7])
  },
  {
    value: 250,
    text: window.$xinI18n('八', 'Home-shortcut-ba') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [250])
  },
  {
    value: 222.2,
    text: window.$xinI18n('九', 'Home-shortcut-jiu') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [222.2])
  },
  {
    value: 200,
    text: window.$xinI18n('十', 'Home-shortcut-shi') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [200])
  }
];

export const HousingLoanDeductionOption = [
  {
    value: 0,
    text: window.$xinI18n('不符合，扣除0元', 'Home-shortcut-bufuhekou0yuan')
  },
  {
    value: 500,
    text: window.$xinI18n('夫妻各扣除500元', 'Home-shortcut-fuqige500yuan')
  },
  {
    value: 1000,
    text: window.$xinI18n('仅由一方扣除1000元', 'Home-shortcut-yifangkouchu1000yuan')
  }
];

export const HousingRentDeductionOption = [
  {
    value: 0,
    text: window.$xinI18n('不符合，扣除0元', 'Home-shortcut-bufuhekou0yuan')
  },
  {
    value: 1500,
    text: window.$xinI18n('直辖市、省会城市、计划单列市等，扣除1500元', 'Home-shortcut-shenghuichengshikouchu1500yuan')
  },
  {
    value: 1100,
    text: window.$xinI18n('所在城市户籍人口超过100万，扣除1100元', 'Home-shortcut-chaoguo100wankouchu1100yuan')
  },
  {
    value: 800,
    text: window.$xinI18n('所在城市户籍人口少于100万，扣除800元', 'Home-shortcut-shaoyu100wankouchu800yuan')
  }
];

export const ChildReduceDeductionOption = [
  {
    value: 0,
    text: window.$xinI18n('不符合，扣除0元', 'Home-shortcut-bufuhekou0yuan')
  },
  {
    value: 1000,
    text: window.$xinI18n('仅由一方扣除1000元', 'Home-shortcut-yifangkouchu1000yuan')
  },
  {
    value: 500,
    text: window.$xinI18n('夫妻各扣除500元', 'Home-shortcut-fuqige500yuan')
  }
];